<template>
  <div class="sidebar">
    <div class="transparent navigation navigation--v2">
      <app-logo class="mb-5 pl-4" />
      <v-list class="ps-sidebar" ref="scrollbar">
        <template v-for="(item, k) in menuToUse">
          <!-- submenu -->
          <template v-if="item.items">
            <v-list-group
              v-model='item.active'
              :ripple="false"
              :key='item.title'
              prepend-icon=''
              no-action
              append-icon=''
              :group='item.group'
              @click="selectedMenu = k"
            >
              <template v-slot:activator>
                <v-list-item
                  :ripple="false"
                  active-class="navigation-active"
                  class="my-2 menu-parent"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon v-if='item.action'>
                        {{ item.action }}
                      </v-icon>
                      <span :class="[item.active ? 'font-weight-bold' : 'font-weight-medium', 'fs-14']">
                        {{ textTruncate(item.title) }}
                      </span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon small>{{ item.active ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
              <template v-for='subItem in item.items.filter(i => !i.hidden)'>
                <v-list-item
                  v-if='!subItem.external'
                  :key='serviceId + subItem.title'
                  :exact='subItem.exact'
                  active-class="navigation-active"
                  :to='subItem.to'
                  :ripple="false"
                >
                  <v-list-item-content
                    style="display: block"
                  >
                    <!-- <v-icon v-if='subItem.action' small class='mr-1'>
                      {{ subItem.action }}
                    </v-icon> -->
                    <v-list-item-title style="display: inline; font-size: 13px !important;" class="ml-3">
                      <v-icon class="pr-0 mr-0">mdi-circle-small</v-icon>
                       {{ textTruncate(subItem.title) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-else
                  :key='subItem.title'
                  :exact='subItem.exact'
                  :ripple="false"
                  :href='subItem.to'
                  @click="menuClick(subItem.onClick, [serviceId, $route.query.user])"
                  target='_blank'
                >
                  <v-list-item-content>
                    <v-list-item-title style="font-size: 13px !important;" class="ml-3">
                      <!-- <v-icon v-if='subItem.action' small class='mr-1'>
                        {{ subItem.action }}
                      </v-icon> -->
                      <v-icon class="pr-0 mr-0">mdi-circle-small</v-icon>
                      {{ textTruncate(subItem.title) }}
                      <v-icon small class='mb-1 ml-1'>mdi-open-in-new</v-icon>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
          <!-- single menu item -->
          <template v-else>
            <v-list-item
              :to="item.to"
              :key="item.path"
              :exact="item.exact"
              :ripple="false"
              class="my-2"
              @click="item.onClick ? menuClick(item.onClick, [serviceId, $route.query.user]) && cleanGroup() : cleanGroup()"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon v-if="item.action" class="mr-2">{{ item.action }}</v-icon>
                  <span class="fs-14 font-weight-medium">
                    {{ textTruncate(item.title) }}
                  </span>
                  <v-icon v-if="item.icon" small class="pl-2">
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppLogo from '../Header/AppLogo.vue'
import { sharedMenu, resellerMenu, kvmMenu } from '@/helpers/menu'
import { textTruncate } from '@/helpers/helpers'
import { kvmFeatures, hasKvmFeature } from '@/helpers/kvmFeatures'
import { isKvmServerPath, SERVERS_PATH } from '@/helpers/serverPaths'

export default {
  name: 'ServiceSidebar',
  data: () => ({
    selectedGroupIndex: 0,
    menuToUse: [],
    selectedService: '',
    domains: [],
    show_groups: ['Shared Hosting', 'Reseller Hosting'],
    selectedMenu: false,
  }),
  components: {
    // VuePerfectScrollbar,
    AppLogo,
  },
  computed: {
    ...mapGetters([ 'brand', 'services', 'hosting', 'getResellerPrivileges', ]),
    serviceId () {
      return this.$route.params.hostingid
    },
    // Snapshot of the per-server feature flags for THIS service, so a change
    // (e.g. the server view learning Docker is enabled) rebuilds the menu.
    featureKey () {
      return Object.keys(kvmFeatures).map(f => hasKvmFeature(f, this.serviceId) ? f : '').join(',')
    },
    menuCallback () {
      if (this.$route.path.substring(0, 15) === '/hosting/shared') {
        return sharedMenu
      } else if (this.$route.path.substring(0, 17) === '/hosting/reseller') {
        return resellerMenu
      } else if (isKvmServerPath(this.$route.path)) {
        return kvmMenu
      }
      return () => []
    }
  },
  methods: {
    ...mapActions(['navigateTo']),
    changeDomain (id) {
      this.navigateTo(id)
    },
    textTruncate (text) {
      return textTruncate(text, 32)
    },

    menuClick (handler, params) {
      if (typeof handler !== 'function') return
      handler(...params)
    },
    replaceParameterInMenuItemTo (menuItem, parameterName, value) {
      if (!menuItem.to || typeof parameterName !== 'string' || typeof value !== 'string') {
        return menuItem
      }
      if (typeof menuItem.to === 'string') {
        menuItem.to = menuItem.to.replace(parameterName, value)
      } else if (typeof menuItem.to === 'object' && typeof menuItem.to.path === 'string') {
        menuItem.to.path = menuItem.to.path.replace(parameterName, value)
      }
      return menuItem
    },
    substituteServiceId () {
      const [...navMenu] = this.menuCallback(this.$route.query.user)
      const filteredMenu = this.filterMenuByPrivileges(navMenu)
      navMenu.length = 0
      navMenu.push(...filteredMenu)
      navMenu.forEach((menuItem, index) => {
        if (this.selectedMenu === index + 1) {
          menuItem.active = true
          navMenu[index] = menuItem
        }
        if (!menuItem.to && !menuItem.items) {
          return
        }
        if (menuItem.items) {
          menuItem.items.forEach((subitem, subIndex) => {
            menuItem.items[subIndex] = this.replaceParameterInMenuItemTo(subitem, ':hostingid', this.serviceId)
            if (this.$route.path === menuItem.items[subIndex]?.to?.path) {
              this.selectedGroupIndex = index
            }
          })
        }
        navMenu[index] =
          this.replaceParameterInMenuItemTo(menuItem, ':hostingid', this.serviceId)
      })
      this.menuToUse = navMenu
      this.addBackToItem()
    },
    markActiveMenu () {
      const index = this.selectedGroupIndex + 1
      const el = this.$refs.scrollbar.$el.querySelector(`div.v-list > div.v-list-group:nth-child(${index}) > div`)
      if (!el) {
        return
      }
      el.click()
    },
    cleanGroup () {
      if (this.menuToUse[this.selectedMenu]) {
        this.menuToUse[this.selectedMenu].active = false
      }
      this.selectedMenu = false
      const openedListGroupElement = this.$refs.scrollbar.$el.querySelector(`div.v-list > div.v-list-group--active`)
      if (!openedListGroupElement) {
        return
      }
      openedListGroupElement.click()
    },
    addBackToItem () {
      let title = this.$route.query.user ? 'Reseller Dashboard' : 'Go Back to Websites'
      let to = this.$route.query.user
        ? { name: 'hosting_whm_info', params: { hostingid: this.$route.params.hostingid } }
        : { path: '/websites' }
      if (isKvmServerPath(this.$route.path)) {
        title = 'Go Back to Servers'
        to = { path: SERVERS_PATH }
      }
      this.selectedGroupIndex++
      this.menuToUse.unshift({
        title,
        action: 'mdi-keyboard-backspace',
        show: true,
        to,
        exact: true,
      },)
    },
    parseDomains () {
      this.domains = []
      this.services.forEach(item => {
        if (this.show_groups.indexOf(item.groupname) !== -1) {
          this.domains.push(item)
          if (item.id === this.serviceId) {
            this.selectedService = item
          }
        }
      })
      this.domains.sort((a, b) => a.groupname.localeCompare(b.groupname))
    },
    filterMenuByPrivileges (menuList) {
      const filteredMenu = []
      menuList.forEach((item) => {
        // Per-server items (e.g. KVM Docker) only where that server offers them.
        if (item.requiresFeature && !hasKvmFeature(item.requiresFeature, this.serviceId)) {
          return
        }
        if (!item.requiredPrivilege) {
          filteredMenu.push(item)
          return
        }
        if (this.getResellerPrivileges[item.requiredPrivilege]) {
          filteredMenu.push(item)
        }
      })
      return filteredMenu
    },
  },
  created () {
    this.parseDomains()
  },
  mounted () {
    this.substituteServiceId()
    this.$nextTick(() => {
      this.markActiveMenu()
    })
  },
  watch: {
    '$route' () {
      this.substituteServiceId()
    },
    services () {
      this.parseDomains()
    },
    getResellerPrivileges () {
      this.substituteServiceId()
    },
    featureKey () {
      this.substituteServiceId()
    },
  }
}
</script>
